import { Component, ElementRef, OnInit } from '@angular/core';
import { ThemeService } from 'src/app/setting/theme/service/theme.service';
import { WizardResourceStatService } from './wizard-resource-stat.service';

import { DashboardWidgetLookup, DashboardWidgetContent } from '@serengeti/serengeti-dashboard';
import { Subscription } from 'rxjs';

@DashboardWidgetLookup('WizardResourceStatComponent')
@Component({
  selector: 'app-wizard-resource-stat',
  templateUrl: './wizard-resource-stat.component.html',
  styleUrls: ['./wizard-resource-stat.component.scss']
})
export class WizardResourceStatComponent implements OnInit, DashboardWidgetContent {

  public charts: any[];
  el: any;

  data: any;
  chartElements: any[];

  themeSubscription: Subscription;

  constructor(
    private statService: WizardResourceStatService,
    private themeService: ThemeService,
		private elementRef: ElementRef
  ) {
    this.charts = this.statService.getConfiguration();
  }

  property(): boolean {
    return false;
  }

  configure(setting: any): void {
  }

  ngOnInit() {
    setTimeout(() => {
      const pieChartHeight = (parseInt(this.elementRef.nativeElement.offsetHeight) - 15);

      document.documentElement.style.setProperty('--chartTitleHeight', '44px');
      document.documentElement.style.setProperty('--chartHeaderFontSize', '24px');
      document.documentElement.style.setProperty('--cardPieChart', pieChartHeight + 'px');
      document.documentElement.style.setProperty('--cardPieChartLineWidth', parseInt(pieChartHeight / 8 + "") + 'px');

      this._loadPieCharts();
      this.themeSubscription = this.themeService.changed().subscribe(res => {
        this._loadPieCharts();
      })  
      this.getChartData();
    }, 100);
  }

  private getChartData() {
    this.statService.getData().then(res => {
      this.data = res;
      this._updatePieCharts(this.data);
    });
  }

  private _loadPieCharts() {
    const chartElements = [];
    const themeColors = this.themeService.getThemeColors();
    const dashboardColors = themeColors.chartSeriesColors;

    jQuery('.chart').each(function() {
      const chart = jQuery(this);
      chartElements.push(chart.easyPieChart({
        easing: 'easeOutBounce',
        onStep: (from: number, to: number, percent: number) => {
          jQuery(this).find('.percent-text').text(Number(percent.toFixed(2)));
        },
        barColor: dashboardColors.green,
        trackColor: '#c0c0c0',
        size: parseInt(document.documentElement.style.getPropertyValue('--cardPieChart')),
        scaleLength: 0,
        animation: 2000,
        lineWidth: parseInt(document.documentElement.style.getPropertyValue('--cardPieChartLineWidth')),
        lineCap: 'round',
      }));
    });
    this.chartElements = chartElements;
  }

  private _updatePieCharts(data: any) {
    if (data != null) {
      this.chartElements.forEach((chart, index) => {
        chart.data('easyPieChart').update(data[index].percent);
      });
    }
  }

}
